import { render } from "./WCCartDrawerRoot.vue?vue&type=template&id=3b1a7f24&scoped=true"
import script from "./WCCartDrawerRoot.vue?vue&type=script&lang=js"
export * from "./WCCartDrawerRoot.vue?vue&type=script&lang=js"

import "./WCCartDrawerRoot.vue?vue&type=style&index=0&id=3b1a7f24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1a7f24"]])

export default __exports__